/**
 * Black Week 2026 - Personalisierung
 * Sortiert Hero und Sektionen nach erkannter Persona
 */
(function() {
  const SORT_ORDERS = {
    grillmeister:      ['grillmeister', 'bratwurst_fan', 'steak_connaisseur', 'sonntagskoch', 'schwarzwaelder'],
    bratwurst_fan:     ['bratwurst_fan', 'grillmeister', 'schwarzwaelder', 'steak_connaisseur', 'sonntagskoch'],
    schwarzwaelder:    ['schwarzwaelder', 'sonntagskoch', 'grillmeister', 'bratwurst_fan', 'steak_connaisseur'],
    steak_connaisseur: ['steak_connaisseur', 'grillmeister', 'sonntagskoch', 'bratwurst_fan', 'schwarzwaelder'],
    sonntagskoch:      ['sonntagskoch', 'schwarzwaelder', 'grillmeister', 'bratwurst_fan', 'steak_connaisseur'],
    standard:          ['grillmeister', 'schwarzwaelder', 'bratwurst_fan', 'sonntagskoch', 'steak_connaisseur']
  };

  function getPersona() {
    // 1. UTM-Parameter
    const urlParams = new URLSearchParams(window.location.search);
    const utmPersona = urlParams.get('persona');
    if (utmPersona && SORT_ORDERS[utmPersona]) {
      localStorage.setItem('bw2026_persona', utmPersona);
      return { persona: utmPersona, source: 'UTM' };
    }

    // 2. Customer Tag (via Liquid)
    if (window.customerPersona && SORT_ORDERS[window.customerPersona]) {
      localStorage.setItem('bw2026_persona', window.customerPersona);
      return { persona: window.customerPersona, source: 'Customer Tag' };
    }

    // 3. LocalStorage
    const stored = localStorage.getItem('bw2026_persona');
    if (stored && SORT_ORDERS[stored]) {
      return { persona: stored, source: 'Session' };
    }

    // 4. Standard
    return { persona: 'standard', source: 'Standard' };
  }

  function applyPersonalization() {
    const { persona, source } = getPersona();
    const order = SORT_ORDERS[persona];

    // Debug anzeigen
    const debug = document.getElementById('bw-debug');
    if (debug) {
      debug.style.display = 'block';
      debug.innerHTML = `Persona: <strong>${persona}</strong><br>Quelle: ${source}<br>Reihenfolge: ${order.join(' → ')}`;
    }

    // Hero aktivieren
    document.querySelectorAll('.bw-hero').forEach(hero => {
      hero.classList.remove('active');
      if (hero.dataset.persona === persona) {
        hero.classList.add('active');
      }
    });

    // Sektionen sortieren
    const container = document.getElementById('bw-sections');
    if (container) {
      const sections = Array.from(container.querySelectorAll('.bw-section'));
      
      // Sortieren
      sections.sort((a, b) => {
        return order.indexOf(a.dataset.persona) - order.indexOf(b.dataset.persona);
      });
      
      // Primär markieren
      sections.forEach((section, index) => {
        section.classList.remove('primary');
        if (index === 0) section.classList.add('primary');
        container.appendChild(section);
      });
      
      // Sichtbar machen
      container.classList.add('ready');
    }

    console.log('[BW2026] Persona:', persona, '| Quelle:', source);
  }

  // Starten
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPersonalization);
  } else {
    applyPersonalization();
  }
})();
